import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ContextBackButtonProps {
  /** Explicit route to navigate to (preferred over browser history) */
  to?: string;
  /** Label shown next to the arrow icon */
  label?: string;
  className?: string;
}

/**
 * ContextBackButton — Componente oficial do Design System Netuno.
 * Uso obrigatório em páginas de profundidade ≥ 2 que não possuem
 * navegação lateral direta (sub-dashboards, análises de contrato).
 * 
 * Prioriza navegação explícita (prop `to`) sobre `history.back()`,
 * garantindo retorno previsível e preservação de contexto.
 */
const ContextBackButton: React.FC<ContextBackButtonProps> = ({
  to,
  label = 'Voltar',
  className,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleClick}
      className={cn('gap-1.5 text-muted-foreground hover:text-foreground -ml-2', className)}
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </Button>
  );
};

export { ContextBackButton };
export default ContextBackButton;
